// src/client/game/core/levels/LevelSelection.ts
import { clampLevel, MIN_LEVEL, type LevelId } from "./LevelFactory";

const KEY = "laser_snake_selected_level";

function hasLocalStorage(): boolean {
  try {
    return typeof localStorage !== "undefined";
  } catch {
    return false;
  }
}

/** Returns the last selected starting level (defaults to 1). */
export function getSelectedLevel(): LevelId {
  if (!hasLocalStorage()) return MIN_LEVEL;
  const raw = localStorage.getItem(KEY);
  const n = raw ? Number(raw) : MIN_LEVEL;
  if (!Number.isFinite(n)) return MIN_LEVEL;
  return clampLevel(n);
}

/** Persists the user's preferred starting level. */
export function setSelectedLevel(id: number): LevelId {
  const lvl = clampLevel(id);
  if (hasLocalStorage()) localStorage.setItem(KEY, String(lvl));
  return lvl;
}
